export const NOTICE_FETCH_REQUESTED = 'NOTICE_FETCH_REQUESTED'
export const NOTICE_FETCH_SUCCESS = 'NOTICE_FETCH_SUCCESS'
export const NOTICE_FETCH_FAILED = 'NOTICE_FETCH_FAILED'

export const NOTICE_READ_FETCH_REQUESTED = 'NOTICE_READ_FETCH_REQUESTED'
export const NOTICE_READ_FETCH_SUCCESS = 'NOTICE_READ_FETCH_SUCCESS'
export const NOTICE_READ_FETCH_FAILED = 'NOTICE_READ_FETCH_FAILED'

export const NOTICE_DELETE_REQUESTED = 'NOTICE_DELETE_REQUESTED'
export const NOTICE_DELETE_SUCCESS = 'NOTICE_DELETE_SUCCESS'
export const NOTICE_DELETE_FAILED = 'NOTICE_DELETE_FAILED'

export const NOTICE_PUBLISH_REQUESTED = 'NOTICE_PUBLISH_REQUESTED'
export const NOTICE_PUBLISH_SUCCESS = 'NOTICE_PUBLISH_SUCCESS'
export const NOTICE_PUBLISH_FAILED = 'NOTICE_PUBLISH_FAILED'

export const NOTICE_ALERT_GROUPS_UPDATE_REQUESTED =
  'NOTICE_ALERT_GROUPS_UPDATE_REQUESTED'
export const NOTICE_ALERT_GROUPS_FOR_NEW_NOTICE =
  'NOTICE_ALERT_GROUPS_FOR_NEW_NOTICE'
export const NOTICE_ALERT_GROUPS_SET_DIRTY = 'NOTICE_ALERT_GROUPS_SET_DIRTY'
export const NOTICE_ALERT_GROUPS_REQUESTED = 'NOTICE_ALERT_GROUPS_REQUESTED'
export const NOTICE_ALERT_GROUPS_SUCCESS = 'NOTICE_ALERT_GROUPS_SUCCESS'
export const NOTICE_ALERT_GROUPS_CLOSE_MODAL = 'NOTICE_ALERT_GROUPS_CLOSE_MODAL'
export const NOTICE_ALERT_GROUPS_FAILED = 'NOTICE_ALERT_GROUPS_FAILED'
export const NOTICE_ALERT_GROUPS_RESET = 'NOTICE_ALERT_GROUPS_RESET'
export const NOTICE_ALERT_GROUPS_UPDATE_FAILED =
  'NOTICE_ALERT_GROUPS_UPDATE_FAILED'

export const NOTICE_RESEND_NOTIFICATION_REQUESTED =
  'NOTICE_RESEND_NOTIFICATION_REQUESTED'
export const NOTICE_RESEND_NOTIFICATION_SUCCESS =
  'NOTICE_RESEND_NOTIFICATION_SUCCESS'
export const NOTICE_RESEND_NOTIFICATION_FAILED =
  'NOTICE_RESEND_NOTIFICATION_FAILED'
export const NOTICE_RESEND_NOTIFICATION_RESET =
  'NOTICE_RESEND_NOTIFICATION_RESET'

export const NOTICE_GET_COMMENTS_REQUESTED = 'NOTICE_GET_COMMENTS_REQUESTED'
export const NOTICE_GET_COMMENTS_SUCCESS = 'NOTICE_GET_COMMENTS_SUCCESS'
export const NOTICE_GET_COMMENTS_FAILED = 'NOTICE_GET_COMMENTS_FAILED'

export const NOTICE_GET_COMMENTS_SILENT_REQUESTED =
  'NOTICE_GET_COMMENTS_SILENT_REQUESTED'
export const NOTICE_GET_COMMENTS_SILENT_SUCCESS =
  'NOTICE_GET_COMMENTS_SILENT_SUCCESS'
export const NOTICE_GET_COMMENTS_SILENT_FAILED =
  'NOTICE_GET_COMMENTS_SILENT_FAILED'

export const NOTICE_ADD_COMMENT_REQUESTED = 'NOTICE_ADD_COMMENT_REQUESTED'
export const NOTICE_ADD_COMMENT_SUCCESS = 'NOTICE_ADD_COMMENT_SUCCESS'
export const NOTICE_ADD_COMMENT_FAILED = 'NOTICE_ADD_COMMENT_FAILED'

export const NOTICE_EDIT_COMMENT_REQUESTED = 'NOTICE_EDIT_COMMENT_REQUESTED'
export const NOTICE_EDIT_COMMENT_SUCCESS = 'NOTICE_EDIT_COMMENT_SUCCESS'
export const NOTICE_EDIT_COMMENT_FAILED = 'NOTICE_EDIT_COMMENT_FAILED'

export const NOTICE_DELETE_COMMENT_REQUESTED = 'NOTICE_DELETE_COMMENT_REQUESTED'
export const NOTICE_DELETE_COMMENT_SUCCESS = 'NOTICE_DELETE_COMMENT_SUCCESS'
export const NOTICE_DELETE_COMMENT_FAILED = 'NOTICE_DELETE_COMMENT_FAILED'

export const NOTICE_COMMENT_CHANGE = 'NOTICE_COMMENT_CHANGE'

export const NOTICE_RESET = 'NOTICE_RESET'

export const NOTICE_SET_PINNED_REQUESTED = 'NOTICE_SET_PINNED_REQUESTED'
export const NOTICE_SET_PINNED_SUCCESS = 'NOTICE_SET_PINNED_SUCCESS'
export const NOTICE_SET_PINNED_ERROR = 'NOTICE_SET_PINNED_ERROR'
